/**
 * DirectionalCharacterMovementComponent - constrained movement along a single axis for 2D-style gameplay.
 * Restricts movement to forward/backward or left/right while disabling look rotation.
 * Ideal for side-scrollers, platformers, or games with axis-constrained movement.
 */
import { EngineClass } from '../../systems/ClassRegistry.js';

import { CharacterMovementComponent } from './CharacterMovementComponent.js';

import type { CharacterMovementOptions } from './CharacterMovementComponent.js';

export enum CharacterMovementDirection {
  ForwardBackward = 'forwardBackward',
  LeftRight = 'leftRight',
}

export interface DirectionalCharacterMovementOptions extends Omit<CharacterMovementOptions, 'movementType' | 'lookRightSpeed' | 'lookUpSpeed'> {
  direction?: CharacterMovementDirection;
  autoMove?: boolean;
}

@EngineClass('DirectionalCharacterMovementComponent')
export class DirectionalCharacterMovementComponent extends CharacterMovementComponent {



  public direction: CharacterMovementDirection = CharacterMovementDirection.ForwardBackward;
  public autoMove: boolean = false;

  public override initialize(options?: DirectionalCharacterMovementOptions): void {
    // Force these values regardless of user input
    const modifiedOptions = {
      ...options,
      lookRightSpeed: 0,
      lookUpSpeed: 0,
    } as CharacterMovementOptions;
    super.initialize(modifiedOptions);
    this.direction = options?.direction ?? this.direction;
    this.autoMove = options?.autoMove ?? this.autoMove;
  }

  public override tickPostPhysics(deltaTime: number): void {
    if (this.direction === CharacterMovementDirection.ForwardBackward) {
      // move forward and backward
      this.addRightInput(0);
      if (this.autoMove) {
        this.addForwardInput(1);
      }
    } else {
      // move left and right
      this.addForwardInput(0);
      if (this.autoMove) {
        this.addRightInput(1);
      }
    }
    super.tickPostPhysics(deltaTime);
  }
}
